import { getFunctions, httpsCallable } from "firebase/functions";

import { firebaseApp } from "./firebase";

const functions = getFunctions(firebaseApp, "us-east1");

export type GuestbookC4Submission = {
  authorName: string;
  content: string;
  funeralHomeId: string;
  idempotencyKey: string;
  photo?: { base64: string; fileName: string; mimeType: "image/jpeg" | "image/png" } | null;
  relationship?: string;
  slug: string;
  termsAccepted: true;
  visibility: "display_name" | "first_name";
  website?: string;
};

export function previewPublicGuestbookC4(input: Omit<GuestbookC4Submission, "idempotencyKey">) {
  const text = `${input.authorName} ${input.content}`.normalize("NFKC").replace(/\s+/g, " ").trim();
  const links = text.match(/(?:https?:\/\/|www\.)[^\s]+/gi) ?? [];
  return { canSubmit: input.termsAccepted === true && text.length >= 4 && links.length <= 1, displayName: input.visibility === "first_name" ? `${input.authorName.trim().split(/\s+/)[0] ?? "Guest"}.` : input.authorName.trim(), message: input.termsAccepted ? "Review your memory before sending it for moderation." : "Please acknowledge the guestbook terms before submitting." };
}

export async function submitPublicGuestbookC4(input: GuestbookC4Submission) {
  return (await httpsCallable<GuestbookC4Submission, { duplicate: boolean; entryId: string; message: string; status: "pending"; withdrawalReceipt?: string }>(functions, "submitPublicGuestbookC4Entry")(input)).data;
}

export async function reportPublicGuestbookC4(input: { category: "abuse" | "impersonation" | "privacy" | "self_harm" | "threat" | "other"; details?: string; entryId: string; funeralHomeId: string; reporterContact?: string; slug: string }) {
  return (await httpsCallable<typeof input, { received: true }>(functions, "reportPublicGuestbookC4Entry")(input)).data;
}

export async function requestPublicGuestbookC4Removal(input: { entryId: string; funeralHomeId: string; reason?: string; receipt: string; slug: string }) {
  return (await httpsCallable<typeof input, { received: true }>(functions, "requestPublicGuestbookC4Removal")(input)).data;
}

export async function moderateCentralGuestbookC4(input: { caseId: string; decision: "approved" | "hidden" | "rejected" | "restored"; entryId: string; expectedVersion: number; idempotencyKey: string; reason?: string; reply?: string }) {
  return (await httpsCallable<typeof input, { duplicate: boolean; status: string; version: number }>(functions, "moderateCentralGuestbookC4Entry")(input)).data;
}

export async function reviewCentralGuestbookC4Media(input: { caseId: string; entryId: string; expectedVersion: number; idempotencyKey: string; mediaDecision: "approved" | "rejected"; reason?: string }) {
  return (await httpsCallable<typeof input, { duplicate: boolean; mediaStatus: string; version: number }>(functions, "reviewCentralGuestbookC4Media")(input)).data;
}

export async function createCentralGuestbookC4Keepsake(input: { caseId: string; idempotencyKey: string; purpose: string; requester: string }) {
  return (await httpsCallable<typeof input, { duplicate: boolean; exportId: string; format: "accessible_html_v1"; snapshotVersion: string }>(functions, "createCentralGuestbookC4Keepsake")(input)).data;
}

export function guestbookC4OperationKey(scope: string) {
  return `${scope}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`.replace(/[^A-Za-z0-9_-]/g, "_");
}
